/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import ImageGallery from 'react-image-gallery';

import MediaPlayer from '../widgets/MediaPlayer'
import GenericObjectViewer from '../widgets/GenericObjectViewer'

import "react-image-gallery/styles/css/image-gallery.css";

import { css } from '@emotion/react';
import { RingLoader } from 'react-spinners'

import {AppContext} from '../AppContext';

class ContentGallery extends React.Component
{
  closing = false;
  modalTitle = null;
  elementRef = React.createRef();
  mediaList = [];
  mediaRefs = [];
  currentIndex = 0;
  showPlayButton = true;

  componentDidMount()
  {
    this.setState({spinnerIsSpinning: true});
    for (let x = 0; x < this.props.mediaList.length; x++) this.generateWeblink(this.props.mediaList[x].objectId, x);
  }

  constructor(props)
  {
    super(props);

    this.toggleModal = this.toggleModal.bind(this);
    this.onSlide = this.onSlide.bind(this);
    this.generateObjectWeblink = this.generateObjectWeblink.bind(this);
    this.imageLoaded = this.imageLoaded.bind(this);
    
    this.state =
    {
      mediaList: [],
      mediaIndex: 0,
      modalIsOpen: false,
      showPlayButton: true,
      spinnerIsSpinning: false,
      showFullScreenButton: true
    };
  }

  async generateObjectWeblink(objectId)
  {
    let bodyData = {objectId: objectId, contentDisposition: 'STREAM'};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'generateObjectWeblink', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error generating weblink');
    return result;
  }

  async generateWeblink(objectId, x)
  {
    var slideData;
    var result = await this.generateObjectWeblink(objectId);
    if (undefined === result) return;
    
    switch (this.props.mediaList[x].htmlElement)
    {
      case 'img':
        slideData = { original: result.jsonData.objectWeblink, index: x };
        break;

      case 'Player':
        result = await this.generateObjectWeblink(objectId);
        slideData = { original: result.jsonData.objectWeblink, index: x, renderItem: this.renderPlayer.bind(this) };
        this.showPlayButton = false;
        break;

      case 'object':
        result = await this.generateObjectWeblink(objectId);
        slideData = { original: result.jsonData.objectWeblink, index: x, renderItem: this.renderObjectViewer.bind(this) };
        this.showPlayButton = false;
        break;

      default:
        break;
    }

    this.mediaList[x] = slideData;

    if (this.mediaList.length === this.props.mediaList.length)
    {
      if (1 === this.mediaList.length) this.showPlayButton = false;
      this.setState({mediaList: this.mediaList, modalIsOpen: true, showPlayButton: this.showPlayButton});
    }
  }

  imageLoaded()
  {
    if (this.state.spinnerIsSpinning) this.setState({spinnerIsSpinning: false});
  }

  onSlide(currentIndex)
  {
    if (undefined !== this.mediaRefs[this.currentIndex]) this.mediaRefs[this.currentIndex].stopPlayer();

    this.currentIndex = currentIndex;
  }

  render()
  {
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;
    
    return(
        <Modal className={'modal-lg'} isOpen={this.state.modalIsOpen} toggle={this.toggleModal} autoFocus={false} >
          { 1 === 2 && <ModalHeader toggle={this.toggleModal}>{this.modalTitle}</ModalHeader> }
          <ModalBody>
              { this.state.mediaList.length &&
                <ImageGallery items={this.state.mediaList} showPlayButton={this.state.showPlayButton} showFullScreenButton={this.state.showFullScreenButton} 
                  onSlide={this.onSlide} onImageLoad={this.imageLoaded} lazyLoad={true} />          
              }
            <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
              <RingLoader css={override} size={75} color={'#4A90E2'} loading={this.state.spinnerIsSpinning}/>          
            </div>
          </ModalBody>
          { 1 === 2 && 
          <ModalFooter>
            <Button className="float-right" color="secondary" onClick={this.toggleModal}>Close</Button>
          </ModalFooter>
          }
        </Modal>
      );
  }

  renderObjectViewer(item)
  {
    if (this.state.spinnerIsSpinning) this.setState({spinnerIsSpinning: false});    
    return React.createElement(GenericObjectViewer, { url: item.original, onClose: this.toggleModal });
  }

  renderPlayer(item)
  {
    if (this.state.spinnerIsSpinning) this.setState({spinnerIsSpinning: false});    
//    return React.createElement(MediaPlayer, { url: item.original, onClose: this.toggleModal, onRef: this.mediaRef, mediaListIndex: item.index });
    return React.createElement(MediaPlayer, {url: item.original, setMediaRef: this.setMediaRef.bind(this, item.index)});
  }

  setMediaRef(index, mediaPlayer)
  {
    this.mediaRefs[index] = mediaPlayer;
  }

  toggleModal(event)
  {
    if (this.closing) return;

    if (null !== this.elementRef.current && !this.elementRef.current.canModalClose()) return;

    this.closing = true;
    this.props.onClose();
  }
}

ContentGallery.contextType = AppContext;

export default ContentGallery